const ytRegex =
  /(?:youtu\.be\/|youtube\.com\/(?:watch\?v=|embed\/|v\/|shorts\/|user\/\S*?\/\S*?\/\S*?\/))([\w-]{11})/;

const convertYouTubeLinkToEmbed = (url: string): string => {
  const videoIdMatch = url.match(ytRegex);

  if (videoIdMatch && videoIdMatch[1]) {
    const videoId = videoIdMatch[1];

    return `https://www.youtube.com/embed/${videoId}`;
  }

  return url;
};

export const convertEmbedToYouTubeLink = (embedUrl: string): string => {
  const videoIdMatch = embedUrl.match(
    /https:\/\/www\.youtube\.com\/embed\/([\w-]{11})/,
  );

  if (videoIdMatch && videoIdMatch[1]) {
    const videoId = videoIdMatch[1];
    return `https://www.youtube.com/watch?v=${videoId}`;
  }

  return embedUrl;
};

export const isYTLinkValid = (url: string) => {
  return url.match(ytRegex);
};

export default convertYouTubeLinkToEmbed;
